import { useTheme } from "@emotion/react";

import { Container, CarregandoAnimacao, Logo } from "./styles";
import WaybeLogo from "../../assets/images/loading-logo.svg";

export default function Carregando({
  larguraSpinner = 130,
  larguraImagem = 70,
  margemDiminuirImagem = 97,
  adaptavel = false,
  minHeight = "68vh",
  ...props
}) {
  const tema = useTheme();
  return (
    <div
      style={
        adaptavel
          ? {
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }
          : { minHeight: minHeight }
      }
      {...props}
    >
      <Container>
        <CarregandoAnimacao larguraSpinner={larguraSpinner} />
        <Logo
          src={WaybeLogo}
          larguraImagem={larguraImagem}
          margemDiminuirImagem={margemDiminuirImagem}
        />
      </Container>
    </div>
  );
}
